export default "__VITE_ASSET__NqsLyb8b__"